import useApi from '../utils/axios-pettitions';
import { useAppDispatch, useAppSelector } from '../contexts/hooks';
import { setMode, setOrderFromServer, setPatient, setNotesFromServer, setPanelVisible, setAttachmentFromServer, setFilteresToOrders, setCurrentActiveTab } from '../contexts/slices/orders';
import { CashierFilter, FilteredOrders, StudiesAddType } from '../types/types.orders';
import { newToast } from '../components';
import { convertData, ConvertDataPatient } from '../utils/functions';
import { useNavigate } from 'react-router-dom';
import { setLstAnalitosResulTipoListas } from '../contexts/slices/config';
import { useScreenSize } from '../utils/media-query';
import { setNote } from '../contexts/slices/orders';

const convertToEstudio = (studiesData: StudiesAddType[]) => {
  if (!studiesData) {
    return [];
  }
  const estudios: any = [];
  let studio: { [key: string]: any } = {};
  for (const study of studiesData) {
    studio = {};
    const dyn: any = [];
    if (study.AditionalFields) {
      for (const [equivalencia, valor] of Object.entries(study.AditionalFields)) {
        dyn.push({ Equivalencia: equivalencia, Valor: valor });
      }
    }
    for (const key in study) {
      if (key === 'AditionalFields') {
        continue;
      }
      studio[key] = study[key];
    }
    estudios.push({ Data: studio, Dyn: dyn });
  }
  return estudios;
};

export const useApiOrders = () => {
  const { runApi } = useApi();
  const dispatch = useAppDispatch();
  const data = useAppSelector((x) => x.globalOrders.CurrentOrder);
  const mode = useAppSelector((x) => x.globalOrders.CurrentOrder.Mode);
  const Prm_Conf_Campos_Diseno = useAppSelector((x) => x.userInfo.Permissions?.Prm_Conf_Campos_Diseno) ?? false;
  const Prm_Res = useAppSelector((x) => x.userInfo.Permissions?.Prm_Res);
  var currentFilters = useAppSelector((x) => x.globalOrders.FiltersToOrders);
  const modeEditor = useAppSelector((x) => x.configuration.IsEditing);
  const idOrd = useAppSelector((x) => x.globalOrders.CurrentOrder.IdOrder);
  const currentPath = useAppSelector((x) => x.notifications.CurrentPath);
  const { isSmall, isXSmall } = useScreenSize();
  // const { DataChangeId } = useAppSelector((x) => x.signalR);
  const navigate = useNavigate();

  const newOrder = async () => {
    const order: { [key: string]: any } = {};
    const study: { [key: string]: any } = {};
    //const dynStudy: any[] = [];
    const dyn: any[] = [];
    for (const key in data.OrderData) {
      if (key === 'AditionalFields') {
        continue;
      }
      order[key] = data.OrderData[key];
    }

    for (const key in data.StudiesData) {
      if (key === 'AditionalFields') {
        continue;
      }
      study[key] = data.StudiesData[key];
    }

    for (const key in data.OrderData.AditionalFields) {
      const valor = data.OrderData.AditionalFields[key];
      dyn.push({ Equivalencia: key, Valor: valor });
    }
    const estudios = convertToEstudio(data.StudiesData);
    const resultado = { Orden: order, Dyn: dyn, Estudios: estudios };
    const copyMode = mode;
    dispatch(setMode({ mode: 'loading' }));
    return runApi('Orders/newOrder', 'POST', null, resultado)
      .then((res) => {
        if (res.internalCode >= 200) {
          dispatch(setMode({ mode: copyMode }));
          return null;
        }
        if (res.internalCode === 105) {
          dispatch(setMode({ mode: 'view' }));
          const newData = convertData(res.data);
          dispatch(setOrderFromServer(newData));
          newToast('SUCCESS', res.message, 5);
          return res.data.Orden.Ord_Id;
        }
      })
      .catch((err) => {
        dispatch(setMode({ mode: 'view' }));
        newToast('ERROR', err.message, 5);
        return null;
      });
  };

  const updateOrder = async () => {
    const order: { [key: string]: any } = {};
    const study: { [key: string]: any } = {};
    const dyn: any[] = [];
    for (const key in data.OrderData) {
      if (key === 'AditionalFields') {
        continue;
      }
      order[key] = data.OrderData[key];
    }

    for (const key in data.StudiesData) {
      if (key === 'AditionalFields') {
        continue;
      }
      study[key] = data.StudiesData[key];
    }

    for (const key in data.OrderData.AditionalFields) {
      const valor = data.OrderData.AditionalFields[key];
      dyn.push({ Equivalencia: key, Valor: valor });
    }
    const estudios = convertToEstudio(data.StudiesData);
    const resultado = { Orden: order, Dyn: dyn, Estudios: estudios };
    dispatch(setMode({ mode: 'loading' }));

    runApi('Orders/updateOrder', 'POST', null, resultado).then((res) => {
      if (res.internalCode >= 200) {
        dispatch(setMode({ mode: 'view' }));
        newToast('ERROR', res.message, 5);
        return;
      }
      if (res.internalCode === 107) {
        dispatch(setMode({ mode: 'view' }));
        const newData = convertData(res.data);
        dispatch(setOrderFromServer(newData));
        newToast('SUCCESS', res.message, 5);
      }
    });
    return;
  };

  const checkExistentOrderByConsec = async (consec: string) => {
    if (!consec) {
      return;
    }
    return runApi('Orders/checkExistentOrderByConsec', 'GET', { consec }, null).then((res) => {
      if (res.internalCode >= 200) {
        return null;
      }
      if (res.internalCode === 101) {
        return res.data;
      }
    });
  };

  const findOrder = async (consec?: string, idOrden?: number, setLoading?: (state: boolean) => void, isDirectSearch: boolean = false) => {
    // Si es búsqueda directa (isDirectSearch=true), limpiar Redirect ANTES de la petición
    // para evitar que useFilterAutoExecution o RightOrdersPanelDetails ejecuten GetOrdersByFilter
    if (isDirectSearch && currentFilters) {
      dispatch(setFilteresToOrders({
        ...currentFilters,
        Redirect: false,
      }));
    }
    
    // NO modificar filtros al buscar una orden - esto causaba re-renders innecesarios en OrdResults
    runApi('Orders/getOrder', 'GET', { consec, idOrder: idOrden ? idOrden : idOrd }, null)
      .then((res) => {
        if (res.internalCode >= 200) {
          //Limpiamos todo
          dispatch(setMode({ mode: 'view', idOrd: -1, idTran: undefined }));
          return;
        } else if (res.internalCode === 104) {
          newToast('INFO', res.data, 3);
          return;
        }
        if (res.internalCode === 101) {
          //Procesa data
          // if (!DataChangeId) {
          //   return;
          // }
          const dataOrden = res.data.Orden;
          const dataOrd = convertData(dataOrden);
          const dataPac = ConvertDataPatient(res.data.Paciente);
          dispatch(setOrderFromServer(dataOrd));
          dispatch(setPatient(dataPac));
          dispatch(setNotesFromServer(res.data.Notas));
          dispatch(setAttachmentFromServer(res.data.Adjuntos));
          if (isSmall || isXSmall) {
            dispatch(setPanelVisible(false));
          }
          
          // Si es búsqueda directa, ir a la tab apropiada según permisos
          // Tab 2 (Resultados) si tiene Prm_Res, sino Tab 1 (Studies)
          if (isDirectSearch) {
            dispatch(setCurrentActiveTab(Prm_Res ? 2 : 1));
          }
          
          // Solo navegar a /admin-orders si NO estamos allí
          if (currentPath !== '/admin-orders') {
            navigate('/admin-orders'); // Sin state, preserva el tab actual
          }
        } else {
          dispatch(setMode({ mode: 'view', idOrd: -1, idTran: undefined }));
        }
      })
      .finally(() => {
        if (setLoading) {
          setLoading(false);
        }
      });
  };

  const getHeaderOrderById = async (idOrder: number) => {
    if (!idOrder || idOrder === -1) {
      return null;
    }
    return runApi('Orders/getHeaderOrderById', 'GET', { idOrder }, null).then((res) => {
      if (res.internalCode === 101) {
        return res.data;
      }
      if (res.internalCode >= 200) {
        newToast('ERROR', res.message, 5);
        return null;
      }
      return null;
    });
  };

  const newNote = async (note: string) => {
    if (!idOrd || idOrd === -1) {
      return;
    }
    runApi('Orders/newNote', 'POST', { idOrden: idOrd, nota: note }, null).then((res) => {
      if (res.internalCode >= 200) {
        return;
      } else if (res.internalCode === 104) {
        newToast('INFO', res.data, 3);
        return;
      }
      if (res.internalCode === 105) {
        newToast('SUCCESS', res.message, 5);
        dispatch(setNote(res.data));
      }
    });
  };

  const updateNote = async (noteId: number, note: string) => {
    if (!idOrd || idOrd === -1) {
      return;
    }
    return runApi('Orders/updateNote', 'POST', { idNota: noteId, nota: note }, null).then((res) => {
      if (res.internalCode >= 200) {
        newToast('ERROR', res.message, 5);
        return false;
      }
      if (res.internalCode === 107) {
        newToast('SUCCESS', 'Acción realizada con éxito', 4);
        findOrder(); // Recargar las notas
        return true;
      }
    });
  };

  const deleteNote = async (noteId: number) => {
    if (!idOrd || idOrd === -1) {
      return;
    }
    return runApi('Orders/deleteNote', 'POST', { idNota: noteId }, null).then((res) => {
      if (res.internalCode >= 200) {
        newToast('ERROR', res.message, 5);
        return false;
      }
      if (res.internalCode === 108) {
        newToast('SUCCESS', 'Acción realizada con éxito', 4);
        findOrder(); // Recargar las notas
        return true;
      }
    });
  };

  const handleSaveDesign = async (value) => {
    if (!modeEditor || !Prm_Conf_Campos_Diseno) {
      return;
    }

    if (value) {
      for (let i = 0; i < value.columns.length; i++) {
        value.columns[i].filterValue = null;
      }
      runApi('Configuration/getDiseno', 'GET', { Id: 'GridResults', Data: JSON.stringify(value) }, null).then((res) => {
        if (res.internalCode >= 200) {
          return;
        } else if (res.internalCode === 101) {
          newToast('INFO', res.message, 3);
          return;
        }
      });
    }
  };

  const getLstBacteriologist = async () => {
    await runApi('Configuration/getLstBacteriologist', 'GET', null, null).then((res) => {
      if (res.internalCode === 101) {
        //insertamos en la configuración
        dispatch(setLstAnalitosResulTipoListas(res.data.lstAnalitosResultTipoListas));
      }
    });
  };

  const deleteOrder = async (noteDelete: string) => {
    await runApi('Orders/deleteOrder', 'POST', { idOrd, noteDelete }, null).then((res) => {
      if (res.internalCode === 108) {
        //insertamos en la configuración
        dispatch(setMode({ mode: 'view', idOrd: -1 }));
        newToast('SUCCESS', res.message, 5);
        return;
      }
      if (res.internalCode === 209) {
        newToast('WARNING', res.messageDetails, 5);
      }
    });
  };

  const handleLoadDesign = async () => {
    const item = await runApi('Configuration/getDiseno', 'GET', { Id: 'GridResults' }, null).then((res) => {
      if (res.internalCode >= 200) {
        return null;
      } else if (res.internalCode === 101) {
        if (res.data.Ds_Data) {
          const dataret = JSON.parse(res.data.Ds_Data);
          return dataret;
        }
        return null;
      }
    });
    return item;
  };

  const transferOrder = async (idPac: number, noteConfirm: string) => {
    return await runApi('Orders/putTransferOrder', 'POST', { idOrd, idPac, noteConfirm }, null).then(async (res) => {
      if (res.internalCode === 210) {
        newToast('ERROR', res.messageDetails, 5);
        return false;
      }
      if (res.internalCode === 107) {
        newToast('SUCCESS', res.message, 5);
        await findOrder();
        return true;
      }
    });
  };

  const GetOrdersByFilter = async (data: FilteredOrders) => {
    if (!data) {
      return [];
    }    
    // limpiamos la orden actual para evitar conflictos
    dispatch(setMode({ mode: 'view', idOrd: -1 }));
    return await runApi('Orders/getFilteredOrders', 'POST', null, data).then((res) => {
      if (res.internalCode === 101) {
        return res.data;
      }
      if (res.internalCode >= 200) {
        newToast('ERROR', res.message, 5);
        return [];
      }
      return [];
    });
  };

  
  const GetOrdersByFilterForMasive = async (data: FilteredOrders) => {
    if (!data) {
      return [];
    }    
    // limpiamos la orden actual para evitar conflictos
    dispatch(setMode({ mode: 'view', idOrd: -1 }));
    return await runApi('Orders/getFilteredOrdersForMasive', 'POST', null, data).then((res) => {
      if (res.internalCode === 101) {
        return res.data;
      }
      if (res.internalCode >= 200) {
        newToast('ERROR', res.message, 5);
        return [];
      }
      return [];
    });
  };

  const GetCashierOrderPass = async (idOrden: number) => {
    if (!data) {
      return;
    }
    return await runApi('Orders/getCashierOrderPass', 'GET', { idOrden }, null).then((res) => {
      if (res.internalCode === 101) {
        return res.data;
      }
    });
  };

  const CreateCashierOrder = async (data: any) => {
    return runApi('Orders/createCashierOrder', 'POST', null, data).then((res) => {
      if (res.internalCode == 105) {
        return res.data;
      } else {
        newToast('ERROR', res.message, 5);
        return null;
      }
    });
  };

  const NewOrderFromPreOrders = async (data: any) => {
    return runApi('Orders/NewOrderFromPreOrders', 'POST', null, data).then((res) => {
      if (res.internalCode == 105) {
        return res.data;
      } else {
        newToast('ERROR', res.message, 5);
        return null;
      }
    });
  };

  const GetCashierOrder = async (data: CashierFilter) => {
    return runApi('Orders/GetCashierOrder', 'POST', null, data).then((res) => {
      if (res.internalCode === 101) {
        return res.data;
      }
    });
  };

  const GetSampleTypeAndBarcode = async (lstIds: number[]) => {
    const query = lstIds.map((id) => `lstIds=${encodeURIComponent(id)}`).join('&');
    return runApi(`Orders/GetSampleTypeAndBarcode?${query}`, 'GET', null, null).then((res) => {
      if (res.internalCode === 101) {
        return res.data;
      }
      return [];
    });
  };

  return { newOrder, checkExistentOrderByConsec, NewOrderFromPreOrders, updateOrder, findOrder, getHeaderOrderById, newNote, handleSaveDesign, handleLoadDesign, getLstBacteriologist, deleteOrder, transferOrder, GetOrdersByFilter,GetOrdersByFilterForMasive, CreateCashierOrder, GetCashierOrderPass, GetCashierOrder, updateNote, deleteNote, GetSampleTypeAndBarcode };
};
